import { useState, useEffect } from 'react'
import { getMe } from '../lib/api'

export function useAuth() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    getMe().then(u => {
      setUser(u)
      setLoading(false)
    }).catch(() => {
      setUser(null)
      setLoading(false)
    })
  }, [])
  
  return { user, loading, isAdmin: user?.role === 'admin', isAuthenticated: !!user }
}
